import api from '../utils/api'
export const PeopleOriented = (headers, params) => {
  // 人群定向请求
  return api.request({
    url: 'addPartner',
    method: 'get',
    headers: headers,
    params: params
  })
}
export const Peoplenews = (headers, params) => {
  // 人群定向请求
  return api.request({
    url: 'get/news',
    method: 'get',
    headers: headers,
    params: params
  })
}
export const accumulation = (headers, params) => {
  // 点击数累加
  return api.request({
    url: '/api/get/addNewsNum',
    method: 'post',
    headers: headers,
    params: params
  })
}
export const getCoo = (headers, params) => {
  // 点击数累加
  return api.request({
    url: '/api/get/getCoo',
    method: 'post',
    headers: headers,
    params: params
  })
}
